import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { AppBar, Toolbar, Box, Link, useTheme, useMediaQuery } from '@mui/material';
import { theme } from '../../constants/theme';
import { ThspianFullLogo } from '../ThspianLogo/ThspianFullLogo';
import { ROUTES } from '../../types/global/routes.types';
import { en_config } from '../../config';
import { Situation } from '../Situation/Situation';
import { GoHomeButton } from '../GoHomeButton/GoHomeButton';
import { ThemeToggle } from '../ThemeToggler/ThemeToggle';

interface ILoginHeader {}

const LoginHeader: React.FC<ILoginHeader> = () => {
    const { themeStyle } = useThemeContext();
    const muiTheme = useTheme();
    const isBg = useMediaQuery(muiTheme.breakpoints.up(1200));

    return (
        <Box
            style={{
                width: '100vw',
                position: 'absolute',
                top: 0,
            }}>
            <AppBar
                position="static"
                style={{
                    backgroundColor: theme[themeStyle].transparent,
                    boxShadow: 'none',
                }}>
                <Toolbar
                    sx={{
                        paddingInline: { xs: '16px', md: '24px', lg: '40px' },
                        paddingTop: { xs: '32px', sm: '40px' },
                        paddingBottom: { xs: '32px', sm: '40px' },
                    }}>
                    <Box display="flex" flexGrow={1}>
                        <Link
                            href={ROUTES.FEED}
                            sx={{
                                width: { xs: '125px', sm: '170px' },
                                height: { xs: '18px', sm: '24px' },
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 99999,
                            }}>
                            <ThspianFullLogo width={'120px'} height={'40px'} fill={theme[themeStyle].logo_color} />
                            {en_config.IS_BETA && <Situation label="beta" />}
                        </Link>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end',
                            width: '40%',
                        }}>
                        <ThemeToggle />
                    </Box>
                    <GoHomeButton isBg={isBg} />
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export { LoginHeader };
